interface IconProps {
  color?: string;
  className?: string;
}

export default function ShareIcon({ color = "#8E929E", className = "" }: IconProps) {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="0.5" y="0.5" width="23.5321" height="23.5321" rx="4.5" stroke={color}/>
      <path d="M15.4677 7.03343L5.09507 15.1893L11.3633 14.0873L13.2681 19.9449L15.4677 7.03343Z" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
